var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"buttonsContainer"},[_vm._l((_vm.setButtonVisibility),function(button){return _c('ButtonsWrapper',{key:button._id,attrs:{"button":button,"setCounterSlideDimensions":_vm.setCounterSlideDimensions,"currentTime":_vm.currentTime}})}),(_vm.showChatGroups)?_c('ChatGroupMonitor'):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }